var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2198_24585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 -5.16406H20V26.5026H10V-5.16406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.16406H10V26.5026H0V-5.16406Z",
    fill: "#006233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2496 8.79297C12.8368 8.07807 12.1997 7.51932 11.437 7.20342C10.6744 6.88752 9.82875 6.83209 9.03138 7.04574C8.234 7.25939 7.52943 7.73019 7.02688 8.38512C6.52435 9.04002 6.25195 9.84247 6.25195 10.668C6.25195 11.4935 6.52435 12.2959 7.02688 12.9508C7.52943 13.6057 8.234 14.0765 9.03138 14.2902C9.82875 14.5038 10.6744 14.4484 11.437 14.1325C12.1997 13.8166 12.8368 13.2579 13.2496 12.543C12.8611 13.0282 12.3315 13.3807 11.734 13.5519C11.1365 13.7231 10.5006 13.7045 9.9141 13.4987C9.32763 13.2928 8.81958 12.9099 8.46015 12.4028C8.10073 11.8957 7.90768 11.2895 7.90768 10.668C7.90768 10.0464 8.10073 9.44022 8.46015 8.93314C8.81958 8.42604 9.32763 8.04312 9.9141 7.83727C10.5006 7.63142 11.1365 7.61282 11.734 7.78402C12.3315 7.95522 12.8611 8.30777 13.2496 8.79297ZM13.3746 10.668L9.99955 9.56797L12.0996 12.443V8.89297L9.99955 11.768L13.3746 10.668Z",
    fill: "#D21034"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2198_24585"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDz);
export default __webpack_public_path__ + "static/media/DZ.a824a2e0ea395ef60f24e1bd67a5458a.svg";
export { ForwardRef as ReactComponent };